import { JhiFilterPipe } from './filter.pipe';
import * as i0 from "@angular/core";
export class JhiPureFilterPipe extends JhiFilterPipe {
    transform(input, filter, field) {
        return super.transform(input, filter, field);
    }
}
JhiPureFilterPipe.ɵfac = /*@__PURE__*/ function () { let ɵJhiPureFilterPipe_BaseFactory; return function JhiPureFilterPipe_Factory(t) { return (ɵJhiPureFilterPipe_BaseFactory || (ɵJhiPureFilterPipe_BaseFactory = i0.ɵɵgetInheritedFactory(JhiPureFilterPipe)))(t || JhiPureFilterPipe); }; }();
JhiPureFilterPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "pureFilter", type: JhiPureFilterPipe, pure: true });
